export const formatCompletion = (completion: number, fractionDigits = 1) =>
  `${completion.toFixed(fractionDigits)}%`

export const completionScoreBandColor = (value: number): string =>
  value >= 100
    ? 'success.dark'
    : value > 80
      ? 'success.light'
      : value > 50
        ? 'warning.main'
        : 'error.light'

export const getColorFromGradient = (percentage: number) => {
  const gradient = [
    {percent: 0, color: [218, 9, 1]},
    {percent: 25, color: [229, 84, 25]},
    {percent: 50, color: [186, 145, 40]},
    {percent: 75, color: [29, 168, 82]},
    {percent: 100, color: [0, 116, 67]}
  ]

  let lowerBound, upperBound
  for (let i = 0; i < gradient.length - 1; i++) {
    if (percentage >= gradient[i].percent && percentage <= gradient[i + 1].percent) {
      lowerBound = gradient[i]
      upperBound = gradient[i + 1]
      break
    }
  }

  const lowerColor = lowerBound.color
  const upperColor = upperBound.color

  const lowerPercent = lowerBound.percent
  const upperPercent = upperBound.percent

  const range = upperPercent - lowerPercent
  const percentDelta = percentage - lowerPercent
  const color = lowerColor.map((channel: number, index: number) => {
    const channelDelta = upperColor[index] - channel
    return Math.round(channel + (percentDelta / range) * channelDelta)
  })

  return `rgb(${color.join(',')})`
}
